import { render, staticRenderFns } from "./CodeSample.vue?vue&type=template&id=10c617ae&lang=pug&"
import script from "./CodeSample.vue?vue&type=script&lang=js&"
export * from "./CodeSample.vue?vue&type=script&lang=js&"
import style0 from "./CodeSample.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports